<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    no-data-text="Раздел не найден"
    :request="request"
    :label="label"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import { LkEventPublicationsStoragesApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'
import BAutocomplete from '../BAutocomplete.vue'

export default {
  name: 'BAutocompleteEventPublicationsStorages',
  components: {
    BAutocomplete,
  },
  mixins: [openApiMixin],
  props: {
    publication: Number,
    label: {
      type: String,
      default: 'Выберите хранилище',
    },
  },
  created() {
    const api = new LkEventPublicationsStoragesApi()
    this.adapter = new Adapter(api)
  },
  methods: {
    request() {
      return this.publication && this.adapter.api.getPublications(this.publication)
    },
  },
}
</script>
